<template>
    <div>
        <div class="row">
            <div class="col-8">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>{{$t("building")}}s of Complex {{buildingName}}</span>

                </div>
            </div>
            <div class="col-4 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <!--<span style="margin-right:5px">Add New Unit</span>
                        <router-link class="btn btn-table" :to="{
                  name: 'property',
                  params: { buildingId: buildingId, buildingName: buildingName },
                }"><i class="fas fa-plus"></i></router-link>-->
                    <span style="
width: 30px;
height: 30px;
border-radius: 5px;
            background-color: #007DFC;
            color: white;
            display: inline-block;
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
            margin-right:8px;
          ">
                        <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                    </span>

                    <span @click="showSearch()"
                          style="
                          width: 30px;
                          height: 30px;
                          border-radius: 5px;
                          background-color: #007DFC;
                          color: white;
                          display: inline-block;
                          padding-left: 5px;
                          padding-right: 5px;
                          text-align: center;
                          cursor:pointer;

                          ">
                        <i class="fa fa-search" style="margin-top:7px;" aria-hidden="true"></i>
                    </span>
                    <input type="text" v-if="visibleSearch" class="form-control" name="searchText" id="searchText" style=" display: inline-block; width: 250px; height: 30px;" v-model="filter">
                    <userMenu />
                </div>
            </div>
        </div>
        <div class="row">

            <div class="offset-md-9 col-3 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <span style="margin-right:5px">Add New Building</span>
                    <router-link class="btn btn-table" :to="{ name: 'building', params:{complexId:buildingId, complexName:buildingName} }"><i class="fas fa-plus"></i></router-link>
                </div>
            </div>
        </div>
        

        <div v-if="false" class="row">
            <div class="col-lg-3 col-md-3 col-sm-5 col-12">
                <div class="size">
                    Show
                    <select class="size-select" v-model="size">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                    </select>
                    Entries
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-5 col-12 sortBy" style="margin-bottom:20px">
                Sort By
                <select class="sortBy-select" v-model="sortBy">
                    <option value="Name">Name</option>
                    <option value="City">City</option>
                </select>
            </div>

            <div class="search col-lg-3 col-md-3 col-sm-4 col-6" style="width:190px; margin-top:12px">
                <span class="fa fa-search"></span>
                <input type="text" class="form-control" name="searchText" id="searchText" placeholder="Search Building..." v-model="filter">
            </div>

            <div class="col-lg-3 col-md-3 col-sm-4 col-6" style="margin-bottom:10px; text-align:right">
                <router-link class="btn btn-primary float-md-right" :to="{ name: 'building', params:{complexId:buildingId, complexName:buildingName} }"><div class="board-add">Add building</div></router-link>
            </div>
        </div>

        <!-- <div class="row">
        <div class="col-12"> -->
        <div class="table-responsive">
            <table class="table table-condensed">
                <thead >
                    <tr>
                        <th scope="col">Name</th>
                        <th scope="col">City</th>
                        <th scope="col">Units</th>
                        <th scope="col">Complex</th>
                        <th scope="col" colspan="2" class="text-right" style='padding-right:77px'>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="building  in buildings" :key="building.id" class="clickable-row">
                        <td scope="row" class="clickable-column">
                            <router-link style="display:block" :to="{ name:'properties', params:{buildingId:building.id, buildingName:building.name}}">{{ building.name}}</router-link>
                        </td>
                        <td class="clickable-column">
                            <router-link :to="{ name:'properties', params:{buildingId:building.id, buildingName:building.name}}">{{ building.city}}</router-link>
                        </td>
                        <td class="clickable-column">
                            <router-link :to="{ name:'properties', params:{buildingId:building.id, buildingName:building.name}}">{{ building.numberOfProperties}}</router-link>
                        </td>
                        <td class="clickable-column">
                            <router-link :to="{ name:'properties', params:{buildingId:building.id, buildingName:building.name}}"> <div style="text-align:center;" v-if="building.isComplex">&#10004;</div></router-link>
                        </td>
                        <td style="text-align:right;">
                            <router-link style="display:inline-block;" class="btn btn-table" :to="{ name: 'building', params:{id:building.id} }"><i class="fas fa-pen"></i></router-link>
                            <a style="margin-left:6px;display:inline-block;" class="btn btn-table" @click.prevent="deleteItem(building)"><i class="fas fa-times"></i></a>
                        </td>
                   </tr>
                </tbody>
            </table>
        </div>
        <!-- </div>
    </div> -->
        <!-- MODAL IS HERE -->
        <modal :scrollable="true" name="deleteAlert" @before-open="beforeOpen" height="auto" :minHeight="150" width="400">
            <div class="" role="document">
                <div class="">
                    <!-- Modal content-->
                    <deleteAlert v-on:close="modalClosed" :entity-id="selectedItemId" request="buildings" entity="building" />
                </div>
            </div>
        </modal>
        <div class="table-summary">
            <span>  Showing {{startEntry}} to {{endEntry}} of {{numberOfEntries}} entries </span>
        </div>
        <paginate :page-count="numberOfPages"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="clickCallback"
                  :prev-text="'<'"
                  :next-text="'>'"
                  :container-class="'pagination'"
                  :page-class="'page-item'">
        </paginate>

        <div class="clearfix"> </div>

    </div>
</template>
<script>
import { authenticationService } from "@/_services";
import { Role } from "@/_helpers";
import { mapState, mapActions } from "vuex";
export default {
  data: function () {
    return {
      size: 10,
      sortBy: "Name",
      selectedItemId: 0,
      filter: "",
      pageNumber: 0,
      buildingId: 0,
    //  buildingName: "",
      role: "",
      columns: [
        { name: "name", th: "Name" },
        { name: "city", th: "City" },
        { name: "units", th: "Units" },
        { name: "is_complex", th: "Complex" },
      ],
    };
  },

  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    isAdmin() {
      return this.currentUser && this.currentUser.role === Role.Admin;
    },

      getBuildings() {
          if (!this.buildings) return null;
      var buildings = this.buildings.filter((building) => {
        return building.name.toLowerCase().includes(this.filter.toLowerCase());
      });

      return buildings;
    },
    numberOfEntries() {
      return this.getBuildings.length;
    },
    numberOfPages() {
      let l = this.numberOfEntries,
        s = this.size;
      return Math.ceil(l / s);
    },
    startEntry() {
      if (this.numberOfEntries == 0) {
        return 0;
      }
      if (this.pageNumber + 1 == 1) {
        return 1;
      } else {
        return this.pageNumber * this.size + 1;
      }
    },
    endEntry() {
      if (this.numberOfEntries <= this.size) {
        return this.numberOfEntries;
      } else if (this.numberOfEntries > this.size && this.pageNumber + 1 == 1) {
        return this.size;
      } else if (this.numberOfEntries > this.size && this.pageNumber + 1 > 1) {
        if (this.numberOfEntries - this.size * (this.pageNumber + 1) > 0) {
          return this.size * (this.pageNumber + 1);
        } else {
          return this.numberOfEntries;
        }
      } else {
        return NaN;
      }
    },
    paginatedData() {
      const start = this.pageNumber * this.size,
        end = start + this.size;
      var sortedBuildings = [...this.getBuildings];
      if (this.sortBy == "Name") {
        sortedBuildings.sort((a, b) =>
            a.name.toLowerCase() > b.name.toLowerCase()
            ? 1
                : b.name.toLowerCase() > a.name.toLowerCase()
            ? -1
            : 0
        );
      } else {
        sortedBuildings.sort((a, b) =>
          a.city.toLowerCase() > b.city.toLowerCase()
            ? 1
            : b.city.toLowerCase() > a.city.toLowerCase()
            ? -1
            : 0
        );
      }
      return sortedBuildings.slice(start, end);
    },
  },
  created() {
    authenticationService.currentUser.subscribe((x) => (this.currentUser = x));

    // EventBus.$on('menuDrawerClicked', (drawer)=>{
    //     this.drawer=drawer
    // })
  },

  mounted() {
    this.buildingId = this.$route.params.buildingId;
    //this.buildingName = this.$route.params.buildingName;
    //if(this.$route.params.building != null)
   //   this.$store.commit('building/SET_CURRENT_BUILDING', this.$route.params.building)
   // else
      if (this.$route.params.building != null) {
         this.$store.commit('building/SET_CURRENT_BUILDING', this.$route.params.building)
      }
      else {
          this.fetchBuilding(this.buildingId);
      }
       // this.fetchBuilding(this.buildingId);
    this.fetchStatement();
  },
  directives: {
    confirm: {
      deleted: function () {
        this.deleteAlert();
      },
    },
  },

  methods: {
      ...mapActions("building", ["fetchBuildingsOfComplex", "fetchBuilding"]),
      setBuilding(building) {
          this.$store.commit('SET_CURRENT_BUILDING', building)
      },
    nextPage() {
      this.pageNumber++;
    },
    prevPage() {
      this.pageNumber--;
    },
    clickCallback(pageNum) {
      this.pageNumber = pageNum - 1;
    },
    fetchStatement: function () {
      this.mute = true;
      this.fetchBuildingsOfComplex(this.buildingId);
    },
    modalClosed: function (itemDeleted) {
      if (itemDeleted) this.fetchStatement();
    },
    deleteItem: function destroy(item) {
      this.selectedItemId = item.id;
      this.deleteAlert();
    },
    deleteAlert: function () {
      this.$modal.show("deleteAlert");
    },

    getComplexString(isComplex) {
      if (isComplex) return "Yes";
      return "No";
    },
  },
}; // Our Javascript logic
</script>